<template>
    <div class='lk__cart-item'>
        <div class="d-flex gap-3">
            <img width='40' height="30" class='banks-logo' :src="imgTitle()"/>
            <div class="text-block d-flex flex-column gap-1" style="line-height:1.1">
                <span v-if="data.description != null" class='text-cut me-3 fs-6 text-green'>{{ getShortenedDescription() }}</span>
                <span :style="data.active == 0 ? 'color: gray;' : ''" class='me-3 cursor-pointer fs-5 fw-500 text-cut ' @click="copyToClipboard">
                    {{ isCopied ? 'Скопировано!' : getShortenedValue() }}
                </span>
                <span class='me-3 fs-6 fw-light text-cut '>{{ data?.cryptonetwork?.name || 'unknown' }}</span>
            </div>
            <button class="ms-auto" @click='wallet_delete'>
                <img width="17" height="17" src='/img/ico/ico-danger.svg'/>
            </button>
        </div>
    </div>
</template>

<script>
import noImg from '/public/img/banks/no_title.png';
export default {
    props: ['data', 'crypto'],
    data() {
        return {
            isCopied: false,
        }
    },
    methods: {
        wallet_delete() {
            this.$emit('wallet_delete');
        },
        imgTitle() {
            if (!this.data?.cryptonetwork?.cryptocurrency?.code) return noImg;

            try {
                return require(`/public/static/img/ico/ico-${this.data?.cryptonetwork?.cryptocurrency?.code?.toLowerCase()}.png`);
            } catch (e) {
                return noImg; // Если файла нет, используем заглушку
            }
        },

        getShortenedValue() {
            if (this.data.value) {
                return this.data.value.length > 20 ? this.data.value.substr(0, 16) + '...' + this.data.value.substring(this.data.value.length - 4) : this.data.value;
            }
            if (this.data.wallet_hash) {
                return this.data.wallet_hash.length > 20 ? this.data.wallet_hash.substr(0, 16) + '...' + this.data.wallet_hash.substring(this.data.wallet_hash.length - 4) : this.data.wallet_hash;
            }
            return null; // Возвращаем null, если значение отсутствует
        },
        getShortenedDescription() {
            if (this.data.description) {
                return this.data.description.substr(0, 20);
            }
            return null; // Возвращаем null, если описание отсутствует
        },
        copyToClipboard() {
            navigator.clipboard.writeText(this.data.wallet_hash ? this.data.wallet_hash : this.data.value).then(() => {
                this.isCopied = true;
                setTimeout(() => {
                    this.isCopied = false;
                }, 1000);
            }).catch(err => {
                console.error('Failed to copy: ', err);
            });
        }
    }
}
</script>

<style scoped>
    .text-cut {
        max-width: 200px;
        overflow: hidden;
        text-wrap: nowrap;
        text-overflow: ellipsis;
    }
.fs-7 {
    font-size: 13px;
}
@media (max-width:500px) {
    .fs-7 {
        font-size: 10px;
    }
}
@media (max-width:320px) {
    .text-cut {
        max-width: 158px;
    }
}
</style>
